interface MetricNameRecord {
  id?: string | null
  metric_name?: string | null
}

export type MetricLookupInput<T> =
  | Record<string, T | null | undefined>
  | undefined

export function buildMetricRecordIndexById<
  T extends {
    id?: string | null
  },
>(metricRecords: MetricLookupInput<T>): Record<string, T> {
  const metricRecordsById: Record<string, T> = {}

  for (const record of Object.values(metricRecords || {})) {
    if (record?.id) {
      metricRecordsById[record.id] = record
    }
  }

  return metricRecordsById
}

export function buildMetricNameToIdLookup<T extends MetricNameRecord>(
  metricRecords: MetricLookupInput<T>,
): Record<string, string> {
  const metricNameToId: Record<string, string> = {}

  for (const record of Object.values(metricRecords || {})) {
    if (record?.id && record.metric_name) {
      metricNameToId[record.metric_name] = record.id
    }
  }

  return metricNameToId
}

export function buildMetricIdToNameLookup<T extends MetricNameRecord>(
  metricRecords: MetricLookupInput<T>,
  referenceAliases: Record<string, string> = {},
): Record<string, string> {
  const metricIdToName: Record<string, string> = {}

  for (const record of Object.values(metricRecords || {})) {
    if (record?.id && record.metric_name) {
      metricIdToName[record.id] = record.metric_name
    }
  }

  for (const [referenceId, canonicalId] of Object.entries(referenceAliases)) {
    if (!metricIdToName[referenceId] && metricIdToName[canonicalId]) {
      metricIdToName[referenceId] = metricIdToName[canonicalId]
    }
  }

  return metricIdToName
}

export function buildMetricNameIdLookups<T extends MetricNameRecord>(
  metricRecords: MetricLookupInput<T>,
): {
  metricIdToName: Record<string, string>
  metricNameToId: Record<string, string>
} {
  return {
    metricIdToName: buildMetricIdToNameLookup(metricRecords),
    metricNameToId: buildMetricNameToIdLookup(metricRecords),
  }
}
